"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Skeleton = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var Box_1 = require("../Box");
var theme_get_1 = require("@styled-system/theme-get");
var pulse = function (colorStart, colorEnd) { return (0, styled_components_1.keyframes)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\nfrom {\n  color: ", ";\n  background-color: ", ";\n}\nto {\n  color: ", ";\n  background-color: ", ";\n}\n"], ["\nfrom {\n  color: ", ";\n  background-color: ", ";\n}\nto {\n  color: ", ";\n  background-color: ", ";\n}\n"])), colorStart, colorStart, colorEnd, colorEnd); };
exports.Skeleton = (0, styled_components_1.default)(Box_1.Box)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  animation: ", "\n    750ms ease-in-out infinite alternate;\n"], ["\n  animation: ", "\n    750ms ease-in-out infinite alternate;\n"])), function (props) {
    return pulse((0, theme_get_1.themeGet)("colors.secondary")(props), (0, theme_get_1.themeGet)("colors.tertiary")(props));
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=Skeleton.js.map